import React, { useEffect, useState } from "react";
import { Lesson } from "../../types/Lessons";
import Api from "../../network/Api";
import { Autocomplete, TextField } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';

const LessonSearch = (props: { onClick: (lesson: Lesson) => void } ) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchResults, setSearchResults] = useState<Array<Lesson>>([]);

  useEffect(() => {
    if (searchQuery === "" || searchQuery.length < 3) { return }
    Api.get(`/lessons?limit=10&q=${searchQuery}`).then(result => {
      setSearchResults(result);
    });
  }, [searchQuery]);

  return <Autocomplete
                disableClearable
                options={searchResults}
                getOptionLabel={(lesson) => lesson.headline}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(e, value) => props.onClick(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search lessons learned"
                    variant="outlined"
                    size="small"
                    onChange={(e) => setSearchQuery(e.currentTarget.value)}
                    slotProps={{
                      input: {
                        ...params.InputProps,
                        type: 'search',
                        startAdornment: <SearchIcon color="secondary" />
                      },
                    }}
                  />
                )}
              />
    
}

export default LessonSearch;